import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useRef,
} from "react";
import { useLocation } from "react-router-dom";

type PreviousPathContextType = {
  previousPath: string | null;
};

const PreviousPathContext = createContext<PreviousPathContextType | undefined>(
  undefined,
);

export const PreviousPathProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    previousPathRef.current = location.pathname;
  }, [location.pathname]);

  return (
    <PreviousPathContext.Provider
      //eslint-disable-next-line
      value={{ previousPath: previousPathRef.current }}
    >
      {children}
    </PreviousPathContext.Provider>
  );
};

export const usePreviousPath = (): string | null => {
  const context = useContext(PreviousPathContext);

  if (context === undefined) {
    throw new Error(
      "usePreviousPath must be used within a PreviousPathProvider",
    );
  }

  return context.previousPath;
};
